module.exports = __webpack_public_path__ + "static/media/crystal.8c9ee351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/crystal.png
// module id = 2453
// module chunks = 0